// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconAlbum(Props) {
  var className = Props.className;
  var tmp = {
    height: "1em",
    width: "1em",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
  }));
}
IconAlbum.displayName = "IconAlbum";
var make = IconAlbum;
export { make };
/* react Not a pure module */